import type { SVGProps } from 'react';

const SvgBookmarkBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      clipRule='evenodd'
      d='M5 4.5L5 21L12 16.5L19 21V4.5C19 3.67157 18.3036 3 17.4444 3L6.55556 3C5.69645 3 5 3.67157 5 4.5Z'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgBookmarkBd;
